export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
}

export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

export const isAndroid = () => {
  return /Android/.test(navigator.userAgent)
}

export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent
  
  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    return 'chrome'
  } else if (userAgent.includes('Firefox')) {
    return 'firefox'
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'safari'
  } else if (userAgent.includes('Edg')) {
    return 'edge'
  } else {
    return 'unknown'
  }
}

// Add more specific mobile detection
export const getDeviceType = () => {
  if (isIOS()) return 'ios'
  if (isAndroid()) return 'android'
  if (isMobileDevice()) return 'mobile'
  return 'desktop'
}

// Check if Leap Wallet is likely installed on mobile
export const canOpenLeapWallet = () => {
  const deviceType = getDeviceType()
  
  if (deviceType === 'desktop') {
    return !!window.leap
  }
  
  // For mobile, we assume the user has the app if they're trying to connect
  return true
}